"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ComponentDrawerItemPage"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerItemPage/index.ts
// module id = 653
// module chunks = 0